'use client'
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/keyVisuals.ts
var getKvQuery = ({ carouselLimit = 10 } = {}) => `
id
logo{${IMAGE_QUERY}}
image11{${IMAGE_QUERY}}
image31{${IMAGE_QUERY}}
image32{${IMAGE_QUERY}}
image23{${IMAGE_QUERY}}
carouselCollection(limit: ${carouselLimit}) {
  items {${IMAGE_QUERY}}
}
`;

export {
  getKvQuery
};
//# sourceMappingURL=chunk-WEAY6VCH.mjs.map